export class ObjectHandler {
    constructor(id) {
        this.id = id;
    }

    init() {
		
    }

    destroy() {

    }

	events() {
		
	}
}